// extracted by mini-css-extract-plugin
module.exports = {"commentedBy":"styles_commentedBy__4yMd5","commentsContainer":"styles_commentsContainer__bfP3I"};